import {useTranslation} from "react-i18next";

const FindProperty = () => {

    const { t } = useTranslation();

    return (
        <>
            <div>
                <h4>{t('serviceDetailPage.ricerca-immobili.contentTitle1')}</h4>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText1') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText2') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText3') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText4') as string}}></p>
            </div>
            <div>
                <h4>{t('serviceDetailPage.ricerca-immobili.contentTitle2')}</h4>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText5') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText6') as string}}></p>
                <ul>
                    <li>{t('serviceDetailPage.ricerca-immobili.listItem1')}</li>
                    <li>{t('serviceDetailPage.ricerca-immobili.listItem2')}</li>
                    <li>{t('serviceDetailPage.ricerca-immobili.listItem3')}</li>
                    <li>{t('serviceDetailPage.ricerca-immobili.listItem4')}</li>
                    <li>{t('serviceDetailPage.ricerca-immobili.listItem5')}</li>
                    <li>{t('serviceDetailPage.ricerca-immobili.listItem6')}</li>
                    <li>{t('serviceDetailPage.ricerca-immobili.listItem7')}</li>
                    <li>{t('serviceDetailPage.ricerca-immobili.listItem8')}</li>
                    <li>{t('serviceDetailPage.ricerca-immobili.listItem9')}</li>
                </ul>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText7') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText8') as string}}></p>
            </div>
            <div>
                <h4>{t('serviceDetailPage.ricerca-immobili.contentTitle3')}</h4>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText9') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText10') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText11') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText12') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText13') as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t('serviceDetailPage.ricerca-immobili.contentText14') as string}}></p>
            </div>
        </>
    )
}

export default FindProperty;